module.exports = __webpack_public_path__ + "assets/img/returnBtn-d92d84a3.png";